import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-12 col-lg-6" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "row gx-3 align-items-center" }
const _hoisted_4 = { class: "col-auto" }
const _hoisted_5 = {
  class: "page-icon-card__icon",
  ref: "icon"
}
const _hoisted_6 = { class: "col page-icon-card__title" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col-auto" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-circle-right" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: _ctx.url,
      custom: ""
    }, {
      default: _withCtx(({ navigate }) => [
        _createElementVNode("div", {
          class: "page-icon-card",
          onClick: navigate
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, null, 512)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _hoisted_7
          ])
        ], 8, _hoisted_2)
      ]),
      _: 3
    }, 8, ["to"])
  ]))
}